export default {
  namespaced      : true,
  state           : {
    isOpenModal             : false,
    handleSubmitFunction    : null,
    handleCancelFunction    : null,

    isSubmitLoading         : false,
    isModalFreez            : false,
    
    isDisabledSubmitButton  : false,
  },

  mutations       : {
    setOpenModal(state, value){
      state.isOpenModal = value;
    },

    setHandleSubmitFunction(state, data){
      state.handleSubmitFunction = data;
    },

    setHandleCancelFunction(state, data){
      state.handleCancelFunction = data;
    },

    setIsSubmitLoading(state, value){
      state.isSubmitLoading = value;
    },

    setIsModalFreez(state, value){
      state.isModalFreez = value;
    },

    setIsDisabledSubmitButton(state, value){
      state.isDisabledSubmitButton = value;
    }
  },

  actions         : {
    updateOpenModal(context, payload){
      if(typeof payload.value !== 'undefined'){
        context.commit('setOpenModal', payload.value);
      }

      if(typeof payload.handleSubmitFunction !== 'undefined'){
        context.commit('setHandleSubmitFunction', payload.handleSubmitFunction);
      }

      if(typeof payload.handleCancelFunction !== 'undefined'){
        context.commit('setHandleCancelFunction', payload.handleCancelFunction);
      }

      if(typeof payload.isSubmitLoading !== 'undefined'){
        context.commit('setIsSubmitLoading', payload.isSubmitLoading);
      }

      if(typeof payload.isModalFreez !== 'undefined'){
        context.commit('setIsModalFreez', payload.isModalFreez);
      }

      if(typeof payload.isDisabledSubmimtbutton !== 'undefined'){
        context.commit('setIsDisabledSubmitButton', payload.isDisabledSubmimtbutton);
      }
    }
  }
}